import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
const VIEWER_SEQUENCE = [15, 16, 18, 20];
const COUNTDOWN_MINUTES = 15;
const DAY_NAMES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: COUNTDOWN_MINUTES,
    seconds: 0
  });
  const [dayName, setDayName] = useState(() => DAY_NAMES[new Date().getDay()]);
  const [viewerIndex, setViewerIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      // Keep the weekday label in sync: after 00:00 it rolls over on its own.
      setDayName(DAY_NAMES[new Date().getDay()]);
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          minutes: prev.minutes - 1,
          seconds: 59
        };
        // Restart the 15-minute window so the offer stays live.
        return {
          minutes: COUNTDOWN_MINUTES,
          seconds: 0
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Live viewers counter: cycles 15 -> 16 -> 18 -> 20 -> back to 15, with a
  // slightly randomized interval so it doesn't feel mechanical.
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const tick = () => {
      setViewerIndex(prev => (prev + 1) % VIEWER_SEQUENCE.length);
      timeout = setTimeout(tick, 4000 + Math.random() * 3000);
    };
    timeout = setTimeout(tick, 4000 + Math.random() * 3000);
    return () => clearTimeout(timeout);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const viewers = VIEWER_SEQUENCE[viewerIndex];
  return <section className="py-5 md:py-10 px-4" data-id="element-15" data-mp="k3rr7t4s9bsx">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-2xl mx-auto bg-chem-navy rounded-[2rem] p-6 md:p-10 text-center shadow-2xl border border-white/5" data-id="element-16" data-mp="1zh4ds0uocrry">
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-17" data-mp="x484eu7szzwx">
          <span className="text-xl md:text-2xl" data-id="element-18" data-mp="x6klz69ng89g">⏰</span>
          <h2 className="text-lg md:text-2xl font-black text-white uppercase tracking-tight leading-tight" data-id="element-19" data-mp="1255mz7wq6vyy">
            Oferta válida solo hoy{' '}
            <span className="text-chem-amber" data-id="element-20" data-mp="9f5fr2er56sx">{dayName}</span>
          </h2>
        </div>

        <div className="flex justify-center items-center gap-3 md:gap-6 mb-6" data-id="element-21" data-mp="9dc7jiohqeit">
          {[{
          val: timeLeft.minutes,
          label: 'MIN'
        }, {
          val: timeLeft.seconds,
          label: 'SEG'
        }].map((item, i) => <Fragment key={item.label} data-id="element-22" data-mp="n6toqwtpff5o" data-mpi={i}>
              <div className="flex flex-col" data-id="element-23" data-mp="n7v2xa60ohrm">
                <span className="text-5xl md:text-7xl font-black text-chem-amber tabular-nums" data-id="element-24" data-mp="3mul7xm99jqgo">
                  {formatNumber(item.val)}
                </span>
                <span className="text-[9px] md:text-[11px] font-bold text-white/45 uppercase mt-1" data-id="element-25" data-mp="3qtk86tk1uz1s">
                  {item.label}
                </span>
              </div>
              {i < 1 && <span className="text-4xl md:text-6xl font-black text-white/20 mb-5" data-id="element-26" data-mp="3edkoyuqc10zr">
                  :
                </span>}
            </Fragment>)}
        </div>

        <p className="text-base md:text-lg font-bold text-white mb-8" data-id="element-27" data-mp="35d5wnbeyalmr">
          <span className="text-chem-amber" data-id="element-28" data-mp="30d9ttfhzp08s">OFERTA ESPECIAL DE LANZAMIENTO</span>
          <br data-id="element-29" data-mp="30fcq2h9qjply" />
          El precio de lanzamiento es por tiempo limitado.
        </p>

        <div className="max-w-md mx-auto" data-id="element-30" data-mp="2vl8lu5rutvok">
          <div className="flex justify-between items-end mb-2" data-id="element-31" data-mp="2qmyoppmkkl0b">
            <div className="flex items-center gap-2" data-id="element-32" data-mp="2qldrfs8venyr">
              <div className="w-2 h-2 bg-chem-amber rounded-full animate-pulse" data-id="element-33" data-mp="2mmwkb8pg9dhc" />
              <span className="text-[9px] md:text-[11px] font-bold text-white/55 uppercase tracking-wider" data-id="element-34" data-mp="2hnblcyaa554m">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-[9px] md:text-[11px] font-black text-white uppercase" data-id="element-35" data-mp="gk10bwxcas9v">
              Quedan pocos
            </span>
          </div>
          <div className="h-2.5 bg-white/10 rounded-full overflow-hidden mb-2" data-id="element-36" data-mp="liue7qgjglak">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-chem-amber rounded-full" data-id="element-37" data-mp="6tyb87tc9ygt" />
          </div>
          <p className="text-[9px] font-bold text-white/45 uppercase tracking-widest mb-3" data-id="element-38" data-mp="1wzh3p9odrim">
            68% de los cupos tomados
          </p>

          {/* LIVE VIEWERS */}
          <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-3 py-1.5" data-id="element-39" data-mp="3p1fb00a2pko9">
            <span className="relative flex h-2 w-2" data-id="element-40" data-mp="1iafuf67xe4li">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-chem-turquoise opacity-75" data-id="element-41" data-mp="1n9j1ew7gukw4" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-chem-turquoise" data-id="element-42" data-mp="37s3aydhx4k41" />
            </span>
            <span className="text-[10px] md:text-xs font-bold text-white/75" data-id="element-43" data-mp="32t9zeqm6z36i">
              👀{' '}
              <motion.span key={viewers} initial={{
              opacity: 0,
              y: -4
            }} animate={{
              opacity: 1,
              y: 0
            }} className="inline-block text-white font-black tabular-nums" data-id="element-44" data-mp="3hiefa15ikvbg">
                {viewers}
              </motion.span>{' '}
              personas viendo en este momento
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}